import Pikaday from 'pikaday';
import { scanner } from 'ln/view/Scanner';

export default Pikaday;

scanner.ioc.add( 'pikaday', function( node ) {
	var pikaday = new Pikaday( { 
		field: node.native,
		format: 'DD.MM.YYYY',
		keyboardInput: false
	});

	//force propery formating
	let date = new Date( node.value );
	pikaday.setDate( date );
	return pikaday;
});